import React from 'react';
import './SliderSection.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import img1 from '../asset/globaljourney.webp';
import img2 from '../asset/GlobalEducation.jpg';
import img3 from '../asset/Dreams.png';
import img4 from '../asset/Success.png';

const cards = [
  { image: img1,
    title: 'Start Your Global Journey Today',
    description: 'Pursue higher education in top-ranked universities Experience new cultures and unlock global opportunities.',
  },
  {   image: img2,
    title: 'Achieve More with Global Education',
    description: 'Earn globally recognized degrees from elite institution Boost your career with us.',
  },
  {   image: img3,
    title: 'Your Dreams, Our Guidance',
    description: 'We simplify your study abroad journey from start to finish Expert counseling, visas, and admissions support.',
  },
  { image: img4,
    title: 'Study, Work & Succeed Abroad',
    description: 'Combine education with valuable international work experience Build a future with global skills and exposure.',
  },
];

const SliderSection = () => {
  return (
    <div className="swiper-wrapper-section">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={30}
        navigation
        loop
        autoplay={{ delay: 3000 }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
        }}
      >
        {cards.map((card, index) => (
         <SwiperSlide key={index}>
  <div className="slider-card">
    <img src={card.image} alt="card visual" className="slider-image" />
    <div className="card-content">
      <h2>{card.title}</h2>
      <p>{card.description}</p>
      
    </div>
  </div>
</SwiperSlide>

        ))}
      </Swiper>
    </div>
  );
};

export default SliderSection;

